import { useState } from "react";

const FilterToggle = ({ children }) => {
    const [showFilters, setShowFilters] = useState(false);

    return (
        <div className="w-full flex flex-col gap-2">
            <button
                className="md:hidden self-end text-sm text-gray-600 underline"
                onClick={() => setShowFilters(prev => !prev)}
            >
                {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
            </button>
            <div className={`${showFilters ? "block" : "hidden"} md:block`}>
                {children}
            </div>
        </div>
    );
};

export default FilterToggle;